import React from 'react';
import { SvgProps } from '../icon.types';

function RainRiskIcon({ fillColor = '#2D3049' }: SvgProps) {
  return (
    <svg height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg">
      <defs />
      <path
        d="M9.001 19v3H7v-3h2.001zM17 2v17h-2V2h2zm-7.999.001V17H7V2.001h2.001zM5 2v13H3V2h2zm8 10v2h-2v-2h2zm8-10v10h-2V2h2zm-8 0v8h-2V2h2z"
        fill={fillColor}
        fillRule="evenodd"
      />
    </svg>
  );
}

export { RainRiskIcon };
